"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepProfile = StepProfile;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const react_router_dom_1 = require("react-router-dom");
const antd_1 = require("antd");
const Api = __importStar(require("@src/api"));
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const StepProfile_style_1 = require("./StepProfile.style");
function StepProfile({ closeModal }) {
    const intl = (0, react_intl_1.useIntl)();
    const history = (0, react_router_dom_1.useHistory)();
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const showErrorNotification = () => {
        antd_1.notification.error({
            message: intl.formatMessage({ id: 'onboarding.error.title' }),
            description: intl.formatMessage({ id: 'onboarding.error.description' }),
        });
    };
    const markOnboardingAsCompletedAndGoToProfile = async () => {
        try {
            await Api.Account.markOnboardingAsCompleted();
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
            // @ts-ignore
            history.pushLocalized('/ucet/profil/uprava-profilu');
        }
        catch (_a) {
            showErrorNotification();
        }
        finally {
            closeModal();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(StepProfile_style_1.ProfileStepWrapper, { children: [(0, jsx_runtime_1.jsx)(StepProfile_style_1.WebProfileCheckImage, {}), (0, jsx_runtime_1.jsx)(StepProfile_style_1.TextWrapper, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.profile.text" }) }), (0, jsx_runtime_1.jsx)(StepProfile_style_1.GoToProfileButton, { onClick: markOnboardingAsCompletedAndGoToProfile, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.profile.go_to_profile" }) })] }));
}
